import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import {
    AdornedInput,
    Input,
    IconSearch,
    Adornment,
    Form,
    Spinner,
} from '@zillow/constellation';


const propTypes = {
    initialText: PropTypes.string,
    placeholder: PropTypes.string,
    onSearch: PropTypes.func,
    onSubmit: PropTypes.func,
    isSearching: PropTypes.bool,
};

const defaultProps = {
    initialText: '',
    placeholder: 'Search',
    onSubmit: () => { },
    onSearch: () => { },
    isSearching: false,
};

class SearchBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: props.initialText,
        };

        this.clearSearchTextAndUpdate = this.clearSearchTextAndUpdate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearchDebounced = debounce(this.props.onSearch, 200);
    }

    handleChange(e) {
        const searchText = e.target.value;
        this.setState({ searchText });
        this.handleSearchDebounced(searchText);
    }

    clearSearchTextAndUpdate() {
        this.updateSearchText(defaultProps.initialText);
        this.props.onSearch(defaultProps.initialText);
    }

    updateSearchText(newText = defaultProps.initialText) {
        this.setState({
            searchText: newText,
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.props.onSubmit) this.props.onSubmit(this.state.searchText);
    }

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <AdornedInput
                    data-test="SearchBox-Component"
                    input={(
                        <Input
                            placeholder={this.props.placeholder}
                            onChange={this.handleChange}
                            value={this.state.searchText}
                        />
                    )}
                    rightAdornment={(
                        <Adornment>{this.props.isSearching ? <Spinner /> : <IconSearch />}</Adornment>
                    )}
                />
            </Form>
        );
    }
}

SearchBox.propTypes = propTypes;
SearchBox.defaultProps = defaultProps;

export { SearchBox };
export default SearchBox;
